/*jshint esversion: 6 */

import Vue from 'vue';

// directives
Vue.directive('demo', function (el) {
  el.style.color = 'red';
  el.innerHTML = '<h1>wasn los hier </h1>';
});

Vue.directive('demo2', function (el) {
  el.style.color = 'green';
  el.innerHTML = '<h1>wasn los hier?! </h1>';
});
